import { render, staticRenderFns } from "./_contactUs.vue?vue&type=template&id=b478583a&scoped=true&lang=pug&"
import script from "./_contactUs.vue?vue&type=script&lang=js&"
export * from "./_contactUs.vue?vue&type=script&lang=js&"
import style0 from "./_contactUs.vue?vue&type=style&index=0&id=b478583a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b478583a",
  null
  
)

export default component.exports